module.exports = __webpack_public_path__ + "static/media/buyCar.623c2a27.png";